import { render, staticRenderFns } from "./VDBaseTemplate.vue?vue&type=template&id=d2c6df9e&scoped=true&"
import script from "./VDBaseTemplate.vue?vue&type=script&lang=js&"
export * from "./VDBaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VDBaseTemplate.vue?vue&type=style&index=0&id=d2c6df9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c6df9e",
  null
  
)

export default component.exports